import { useMemo } from 'react';
import { useRouter } from '../../../hooks/useRouter';
import { ChildrenOnly } from '../../../types/ChildrenOnly';
import { parseSearchUrl } from '../urls/parseSearchUrl';
import { SearchFilterContext } from './SearchFilterContext';

export const SearchFilterUrlProvider = ({ children }: ChildrenOnly) => {
  const router = useRouter();

  const filters = useMemo(() => (router ? parseSearchUrl(router.asPath, router.query) : {}), [
    router,
  ]);

  return <SearchFilterContext.Provider value={filters}>{children}</SearchFilterContext.Provider>;
};
